import { Injectable } from '@angular/core';
import { isUndefined } from 'util';

@Injectable()
export class NecModalService {

  private modals: any[] = [];

  add(modal: any) {
    if (this.modals.findIndex(item => item.id === modal.id) === -1) {
      this.modals.push(modal);
    }
  }

  remove(id: string) {
    let modalIdx = this.modals.findIndex(item => item.id === id);
    if (modalIdx !== -1) {
      this.modals.splice(modalIdx, 1);
    }
  }

  open(id: string) {
    let modal = this.modals.find(item => item.id === id);
    if (!isUndefined(modal)) {
      document.body.classList.add('modal-open');
      modal.open();
    }
  }

  close(id: string) {
    let modal = this.modals.find(item => item.id === id);
    if (!isUndefined(modal)) {
      document.body.classList.remove('modal-open');
      modal.close();
    }
  }
}
